import React from 'react';

function Map(props: object) {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.08691 5.18649V11.6732C2.08691 12.9398 3.02721 13.4598 4.1695 12.8332L5.80632 11.9398C6.16154 11.7465 6.75358 11.7265 7.12274 11.9065L10.7795 13.6598C11.1486 13.8332 11.7406 13.8198 12.0959 13.6265L15.1118 11.9732C15.4949 11.7598 15.8153 11.2398 15.8153 10.8132V4.32649C15.8153 3.05982 14.875 2.53982 13.7327 3.16649L12.0959 4.05982C11.7406 4.25315 11.1486 4.27315 10.7795 4.09315L7.12274 2.34649C6.75358 2.17315 6.16154 2.18649 5.80632 2.37982L2.7904 4.03315C2.40035 4.24649 2.08691 4.76649 2.08691 5.18649Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.4541 2.6665V11.3332"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4482 4.41309V13.3331"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Map;
